import { render } from "./TwLabel.vue?vue&type=template&id=72fe8afe"
const script = {}

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.30_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__